import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './CircleChallengeGraph.css';

interface CircleChallengeGraphProps {
  title: string;
  subtitle: string;
  value: number | string;
  colour: string;
  width: string;
  icon: IconDefinition;
  unit: string;
  isActive?: boolean;
}

function CircleChallengeGraph({
  title,
  subtitle,
  value,
  colour,
  width,
  icon,
  unit,
  isActive = true,
}: CircleChallengeGraphProps) {
  const titleId = title?.replace(/\s+/g, '');
  const subtitleId = subtitle?.replace(/\s+/g, '');
  return (
    <div
      className={`chart-container circle-challenge tile ${width}`}
      role="group"
      aria-labelledby={`${titleId}-${subtitleId}-circle-challenge-graph-title ${titleId}-${subtitleId}-circle-challenge-graph-subtitle`}
    >
      <div className="title-container">
        <h3 className="title" id={`${titleId}-${subtitleId}-circle-challenge-graph-title`}>
          {title}
        </h3>
        <p className="subtitle" id={`${titleId}-${subtitleId}-circle-challenge-graph-subtitle`}>
          {subtitle}
        </p>
      </div>
      <div className="chart-box">
        <div className="circle_chart">
          <FontAwesomeIcon style={{ color: colour }} icon={icon} className=" icon tile" />
          <p className={`value ${!isActive ? 'ended' : ''} fs-mask`} style={{ color: colour }}>
            {value}
          </p>
          <p className={`unit ${!isActive ? 'ended' : ''} fs-mask`} style={{ color: colour }}>
            {unit}
          </p>
        </div>
      </div>
    </div>
  );
}

export default CircleChallengeGraph;
